import {css} from 'lit';
export const styles = css`:host {
  --background-primary: #fff;
  --background-secondary: var(--secondary);
  --placeholder-text-primary: var(--gray-600);

  display: flex;
  align-items: center;
  border: 4px solid #fff;
  border-radius: 4px;
  background-color: var(--background-primary);
  color: var(--dark-text);
  font-size: 14px;
  overflow: hidden;
  transition: box-shadow ease-in-out 0.2s;
}

ef-img-placeholder {
  margin-right: 8px;
}

.title {
  /* stylelint-disable-next-line value-no-vendor-prefix */
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  margin: 0;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.4em;
  overflow: hidden;
}

.info {
  flex: 1 1 auto;
  color: var(--dark-text-secondary);
  font-size: 0.86em;
  white-space: nowrap;
}

.label {
  display: inline-block;
  padding: 4px 8px;
  background-color: var(--background-secondary);
  border-radius: 4px;
  color: #fff;
  white-space: nowrap;
  vertical-align: baseline;
  line-height: 1;
}

ef-timeago {
  display: block;
  margin-top: 4px;
  line-height: 1;
  white-space: nowrap;
}

.content {
  flex: 1 1 auto;
}

.details {
  margin-left: 8px;
  font-size: 0.86em;
  text-align: right;
}

:host([theme='primary']) .info {
  color: var(--primary);
}

:host([theme='secondary']) .info {
  color: var(--secondary);
}

:host([theme='success']) .info {
  color: var(--success);
}

:host([theme='info']) .info {
  color: var(--info);
}

:host([theme='warning']) .info {
  color: var(--warning);
}

:host([theme='danger']) .info {
  color: var(--danger);
}
`;
export default styles;
